import { useCallback, useContext } from "react";
import AlertContext from "../../../../context/AlertContext";
import useCommonFunctionHooks from "../../../../Hooks/useCommonFunctionHooks";
import CodingViewHooks from "../../../../Hooks/CodingPage/CodingViewHooks";
import useAxiosPrivate from "../../../../Hooks/useAxiosPrivate";
import Tooltip from "../../../CommonComponents/Tooltip";
import { Fragment } from "react";
import IconButton from "../../../CommonComponents/IconButton";
import Table from "../../../CommonComponents/Table";
import constants from "../../../../constants";
import { useEffect } from "react";
import { useState } from "react";
import Button from "../../../Button";
import GraphForAttempts from "../../../Student/MockTestPage/GraphForAttempts";
import { useRef } from "react";
import Loading from "../../../Notification-Loading/Loading/Loading";
import { getDataFromStorage } from "../../../../util";

const calculatePageSize = () => {
  const viewportHeight = window.innerHeight;
  const itemHeight = 42;
  return Math.ceil(viewportHeight / itemHeight);
};

const CCQuestionComponent = ({
  secid,
  ccSecName,
  complexityId,
  debouncedSearchValue,
  qnsFilterValue,
  learnerId,
  from,
  setHeaderData,
}) => {
  const useCommonFunctionHks = useCommonFunctionHooks();
  const { viewCode } = CodingViewHooks();
  const axios = useAxiosPrivate();

  const Alert = useContext(AlertContext);
  const tableRef = useRef(null);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(() => calculatePageSize());

  const [hasMore, setHasMore] = useState(true);
  const [secQuestions, setSecQuestions] = useState([]);
  const [openedRowId, setOpenedRowId] = useState(null);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [buttonClickedOnce, setButtonClickedOnce] = useState(true);
  let data = [];
  const columns = [
    {
      key: "sno",
      title: "S.No",
      className: "serialNo",
    },
    {
      key: "title",
      title: "Question",
      className: "title",
    },
    {
      key: "complexityid",
      title: "Difficulty",
      className: "difficulty",
    },
  ];

  //scroll api call
  useEffect(() => {
    const handleResize = () => {
      setPageSize(calculatePageSize());
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleScroll = () => {
    const el = tableRef.current;
    if (!el || !hasMore || isLoadingData) return; // Fixed typo here

    const { scrollTop, scrollHeight, clientHeight } = el;
    if (scrollTop + clientHeight >= scrollHeight - 50) {
      setPage((prev) => prev + 1);
    }
  };

  useEffect(() => {
    const el = tableRef.current;
    if (el) {
    }
  }, [secQuestions]); // Check when data changes
  useEffect(() => {
    setPage(1);
    setHasMore(true);
    setSecQuestions([]);
  }, [complexityId, debouncedSearchValue, qnsFilterValue]);

  useEffect(() => {
    const fetchSecQuestions = async () => {
      if (!hasMore) return;
      console.log("api call=>", secid);

      if (secid === undefined || secid === null) return;
      setIsLoadingData(true);
      try {
        const response = await axios.get(
          `node/learner/cc/section/${secid}/question?page=${page}&limit=${pageSize}&qns=${true}&learnerId=${learnerId}&from=${
            from ?? ""
          }`,
          useCommonFunctionHks.getHeaderDetailsForAxios()
        );

        if (response.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
          const data = response.data.data.questions || [];
          const totalCount = response.data.data.totalCount;

          setSecQuestions((prev) => {
            const questions = page === 1 ? data : [...prev, ...data];
            // console.log("questions:", questions, "totalCount:", totalCount);
            if (totalCount <= questions.length) setHasMore(false);
            return questions.map((item, index) => ({
              sno: index + 1,
              ...item,
            }));
          });
          if (from === "activitypage") {
            setHeaderData((prev) =>
              prev.map((p) => {
                switch (p.name) {
                  case "Easy":
                    return {
                      ...p,
                      count: `${
                        response?.data?.data?.totalSolved?.easySolved ?? 0
                      }/${response?.data?.data?.easyCount ?? 0}`,
                    };
                  case "Medium":
                    return {
                      ...p,
                      count: `${
                        response?.data?.data?.totalSolved?.mediumSolved ?? 0
                      }/${response?.data?.data?.mediumCount ?? 0}`,
                    };
                  case "Hard":
                    return {
                      ...p,
                      count: `${
                        response?.data?.data?.totalSolved?.hardSolved ?? 0
                      }/${response?.data?.data?.hardCount ?? 0}`,
                    };
                  case "Total":
                    return {
                      ...p,
                      count: `${
                        response?.data?.data?.totalSolved?.totalSolved ?? 0
                      }/${response?.data?.data?.totalCount ?? 0}`,
                    };
                  default:
                    return p;
                }
              })
            );
          }
        } else {
          Alert.setShowNotify({
            show: true,
            title: "Error!",
            msg: "Something went wrong. Please try again later or contact support.",
          });
        }
      } catch (error) {
        useCommonFunctionHks.getCatchBlockDetails(error);
        setHasMore(false);
      } finally {
        setIsLoadingData(false);
      }
    };

    if (Number.isInteger(Number(secid))) fetchSecQuestions();
  }, [page, hasMore, pageSize, secid]);

  // single section details
  const takeTest = (event, data) => {
    event.preventDefault();

    const testData = prepareTestData(data);
    Alert.setTestData(testData);
    Alert.setCurrentStep(0);
    Alert.setCodingTestData(testData);
    Alert.setShowInstruction(true);
    Alert.setStatus(constants.QUESTION_STATUS.ASSIGNED);
    Alert.setTopic({ id: testData.secid, name: testData.secname });
    Alert.navigate("/instruction");
  };
  const prepareTestData = (data, overrides = {}) => {
    return {
      ...data,
      ...overrides,
      single: true,
      instruction: null,
      testmode: constants.MODE.TEST_MODE,
      status: constants.QUESTION_STATUS.ASSIGNED,
      proctored: constants.PROCTORING_MODE.TAB_CAM,
      testtype: constants.libTypeIds.CODING_CHALLENGE,
      configdata: {
        languageid: data.languageid,
      },
    };
  };
  const viewTest = (data) => {
    if (!buttonClickedOnce) {
      console.log("button already clicked");
      return;
    }
    setButtonClickedOnce(false);
    const testData = prepareTestData(data, {
      qndata: [
        {
          status: constants.QUESTION_STATUS.SUBMITTED,
        },
      ],
    });

    Alert.setTestData(testData);
    Alert.setCodingTestData(testData);
    Alert.setTopic({ id: testData.secid, name: testData.secname });
    viewCode(testData, undefined, undefined, learnerId);
  };
  const getColor = (score, targetscore) => {
    return score > targetscore / 2 ? "green" : "red";
  };

  //render row
  const renderCustomRow = (row, rowIndex, columns) => (
    <Fragment key={rowIndex}>
      <tr
        key={rowIndex}
        className={`tableBodyRow ${openedRowId === row.sno ? "opened" : ""}`}
        id={`${rowIndex % 2 === 0 ? "even" : "odd"}`}
      >
        <td className={`tableData sno serialNo`}>{row.sno}</td>
        <td className={`tableData title`}>
          <div className="ccSecQnsTableBodyTitleAndStatusSec">
            <Tooltip placement="bottom" title={row.title}>
              <p className="ccSecQnsTableBodyTitle">{row.title}</p>
            </Tooltip>
            {row.lccid && (
              <Tooltip
                position="bottom"
                title={
                  row.actualscore === row.targetscore
                    ? "Solved"
                    : row.attempteddata?.length
                    ? "Attempted"
                    : ""
                }
                isIcon={true}
              >
                <div
                  className={`ccSecQnsTableBodyStatus ${
                    row.actualscore === row.targetscore
                      ? "solved"
                      : row.attempteddata?.length
                      ? "attempted"
                      : ""
                  }`}
                >
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 3L4.5 8.5L2 6"
                      stroke="#667085"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </Tooltip>
            )}
          </div>
        </td>
        <td className={`tableData difficulty`}>
          <div className="ccSecQnsTableBodyDifficultySec">
            <p className={row?.cname?.toLowerCase()}>
              {row.complexityid === constants.complexityid.HARD
                ? "Hard"
                : row.cname}
            </p>
            <div
              className={`ccSecQnsTableBodyDifficultyUtils ${
                row.sno === openedRowId ? "opened" : ""
              }`}
            >
              {getDataFromStorage("role") === "learner" && (
                <Button
                  size="sm"
                  hierarchy={{ type: "secondaryGrey", buttonText: "Solve" }}
                  onClick={(event) => takeTest(event, row)}
                />
              )}
              {JSON.parse(row?.attempteddata ?? "[]").length ? (
                <IconButton
                  children={
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5 7.5L10 12.5L15 7.5"
                        stroke="#667085"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  }
                  size="sm"
                  hierarchy="tertiaryGrey"
                  onClick={() => {
                    console.log("openId:", openedRowId);

                    setOpenedRowId(openedRowId === row.sno ? null : row.sno);
                    console.log("openId:", openedRowId);
                  }}
                />
              ) : null}
            </div>
          </div>
        </td>
      </tr>
      {openedRowId === row.sno && (
        <tr
          className={`tableBodyRow expandRow`}
          id={`${rowIndex % 2 === 0 ? "even" : "odd"}`}
        >
          <td className="tableData" colSpan={columns.length}>
            {JSON.parse(row?.attempteddata ?? "[]")?.length ? (
              <div
                className={`ccSecQnsTableBodyAttemptSec ${
                  row.sno === openedRowId ? "opened" : ""
                }`}
              >
                <div className="ccSecQnsTableBodyAttemptContainer">
                  {JSON.parse(row?.attempteddata ?? "[]")?.map(
                    (attempt, index) => {
                      const attemptData = {
                        attempt: `${index + 1}`,
                        score: `${attempt?.actualscore}`,
                        targetscore: `${row.targetscore}`,
                      };
                      data.push(attemptData);
                      return (
                        <div
                          className="ccSecQnsTableBodyAttempt"
                          key={index}
                          onClick={() => {
                            console.log("fromPage:",from);
                            
                            if (from !== "activitypage") {
                              viewTest({ ...row, lccid: attempt.attempt_id, questionid: attempt.question_id });
                            }
                            // setButtonClickedOnce(false);
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "2.89px",
                            }}
                          >
                            <p className="ccSecQnsTableBodyAttemptCount">
                              Attempt {index + 1}
                            </p>
                            <p className="ccSecQnsTableBodyAttemptCreated">
                              {attempt.timestamp.split(" ")[0]}
                            </p>
                          </div>
                          <p
                            className={`ccSecQnsTableBodyAttemptScoreSec ${getColor(
                              attempt.actualscore,
                              row.targetscore
                            )}`}
                          >
                            <span className="ccSecQnsTableBodyAttemptScore">
                              {attempt.actualscore}/{row.targetscore}
                            </span>
                          </p>
                        </div>
                      );
                    }
                  )}
                </div>
                {data && data.length >= 2 && (
                  <div className="ccSecQnsTableBodyAttemptGraph">
                    <GraphForAttempts
                      attemptedData={data.length > 4 ? data.slice(-4) : data}
                      page={"ccpage"}
                    />
                  </div>
                )}
              </div>
            ) : null}
          </td>
        </tr>
      )}
    </Fragment>
  );
  return (
    <div
      ref={tableRef}
      onScroll={handleScroll}
      className="ccSecQnsTableContainer"
      style={{
        height: "calc(100vh - 300px)",
        overflowY: "auto",
        scrollbarWidth: "none",
      }}
    >
      {isLoadingData && <Loading overlay/>}
      <Table
        columns={columns}
        data={secQuestions}
        renderRow={renderCustomRow}
      />
    </div>
  );
};

export default CCQuestionComponent;
